import { render, staticRenderFns } from "./RankingTipoPresupuesto.vue?vue&type=template&id=083c4d05&"
import script from "./RankingTipoPresupuesto.vue?vue&type=script&lang=js&"
export * from "./RankingTipoPresupuesto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports